module.exports = __webpack_public_path__ + "static/media/3.98c0cbe0.webp";